import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { Translate, _common } from './_common';

declare const gtag;



const isUpperCase = (string) => /(?=.*[A-Z])/.test(string);
const isLowerCase = (string) => /(?=.*[a-z])/.test(string);
const isNumber = (string) => /(?=.*[0-9])/.test(string);
const isSpecial = (string) => /(?=.*[@#$])/.test(string);


// const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
export const URL_REGEX = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g;


export function validatePassword(length: number, pattern: string): ValidatorFn {

  return (c: AbstractControl): ValidationErrors | null => {


    const v = c.value;
    if (v.length < length)
      return { validatePassword: { valid: false } };

    if (pattern.indexOf('a') >= 0)
      if (!isLowerCase(v)) {
        return { validatePassword: { valid: false } };
      }
    if (pattern.indexOf('A') >= 0)
      if (!isUpperCase(v)) {
        return { validatePassword: { valid: false } };
      }
    if (pattern.indexOf('1') >= 0)
      if (!isNumber(v)) {
        return { validatePassword: { valid: false } };
      }
    if (pattern.indexOf('@') >= 0)
      if (!isSpecial(v)) {
        return { validatePassword: { valid: false } };
      }

    return null;

  }
}
export function validateDomain(): ValidatorFn {

  return (c: AbstractControl): ValidationErrors | null => {

    const v = c.value;
    console.log(v);
    var regex = /^[a-zA-Z0-9\-]+$/g
    if (!regex.test(v))
      return { validateDomain: { valid: false } }


    return null;

  }
}
@Component({
  selector: 'app-sign',
  templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit {

  form: FormGroup;
  error: string;

  app: string;
  subscription: Subscription;
  _common = _common;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.form = this.fb.group({
      accountName: ['', Validators.required],
      domain: ['', [Validators.required, validateDomain()]],
      username: ['', Validators.required],

      email: ['', [Validators.required, Validators.email]],

      phone: ['', Validators.required],
      name: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6), validatePassword(6, 'Aa0')]],

    });

    this.fill_form_values(SignupComponent.value, this.form);
    // this.form.controls['name'].disable()
    this.form.controls['username'].disable()

    let langs = navigator.languages;
    console.log(langs);
    if (langs && langs.length) {
      for (let lang of langs) {
        lang = lang.toLowerCase().replace('-', '_');
        if (lang.startsWith('zh')) {
          this.changeLang('zh_hk');
          break;
        }
      }
    }

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      let locale = params.locale;
      if (locale) {
        this.changeLang(locale);
      }

      SessionService.fixTitle(this.app);
    })

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  city: string;
  country: string;
  timezone: string;


  type = 'password'
  @ViewChild('passwordInput') passwordInput: ElementRef;
  get password() { return this.form.get('password'); }
  get domain() { return this.form.get('domain'); }

  ngOnInit() {


    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


    this.http.get('https://get.geojs.io/v1/ip/geo.json').subscribe((data: any) => {
      this.city = data.city;
      this.country = data.country;
    });

  }
  togglePassword() {
    let ee = this.passwordInput.nativeElement
    if (this.type == 'password') {
      this.type = 'text'
    } else {
      this.type = 'password'
    }
  }
  capitalize(s: string) {
    if (s.length == 0) return s;
    if (s.length == 1) return s.toUpperCase();
    return s.substr(0, 1).toUpperCase() + s.substr(1);
  }

  updateEmail(event: Event) {
    const i = event.target as HTMLInputElement
    let email = i.value;
    let index = email.indexOf('@');
    if (index < 0) return;

    let username = email.substring(0, index);
    let domain = email.substring(index + 1);


    let fullDomain = domain;
    index = domain.indexOf('.');
    if (index >= 0)
      domain = domain.substring(0, index);

    let v = this.form.value;
    switch (fullDomain) {
      case 'gmail.com':
        break;
      default:
        v.domain = domain;
        v.accountName = this.capitalize(domain);
        break;

    }

    v.username = username;

    let parts = username.split(/[.|_]+/);
    parts = parts.map((o) => this.capitalize(o));

    // v.name = parts.join(' ');
    this.fill_form_values(v, this.form);
  }

  fill_form_values(object: any, form: FormGroup, defaultValue?: any) {
    const o = {};
    for (const name in form.controls) {
      o[name] = object[name];
      if (o[name] === null || typeof o[name] === 'undefined') {
        if (defaultValue)
          o[name] = defaultValue[name];

        if (o[name] === null || typeof o[name] === 'undefined') {
          o[name] = '';
        }
      }
    }
    form.setValue(o);
    return o;
  }
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  checkDomain() {

  }
  static value = {};


  proceed() {
    if (!this.form.valid) return this.validateAllFormFields(this.form);
    let domain = this.form.value.domain;

    let email = this.form.value.email;
    let index = email.indexOf('@')
    if (index < 0) {
      this.error = "Invalid email"
      return;
    }

    let username = email.substring(0, index);

    domain = domain.toLowerCase();
    if (domain == 'gmail' ||
      domain == 'gmail.com' ||
      domain == 'facebook' ||
      domain == 'facebook.com' ||
      domain == 'app' ||
      domain == 'test' ||
      domain == 'mall' ||
      domain == 'www'
    ) {
      this.error = 'Invalid domain'
      return;
    }

    const query = Object.assign({}, this.form.value);
    query.username = username;
    query.city = this.city;
    query.country = this.country;
    query.timezone = this.timezone;
    query.app = this.app;
    query.locale = this.lang;
    SignupComponent.value = query;


    this.http.post('/ext/signup/signup', query).subscribe((data: any) => {
      if (!data.succeed) {
        this.error = data.error;
        return;

      }

      this.router.navigate(['/signup_succeed'], {
        queryParams: {
          'email': this.form.value.email,
          'name': this.form.value.name,
          'app': this.app,
        }
      });

    }, (error) => {
      this.router.navigate(['/signup_error'], { queryParams: { app: this.app } });


    });
  }
  lang = 'en'
  changeLang(lang: string) {

    if (Translate[lang]) {
      Object.assign(_common, Translate[lang])
      this.lang = lang;
    } else {
      Object.assign(_common, Translate.en)
      this.lang = 'en'
    }
  }
}
